export default __webpack_public_path__ + "static/media/10.608aef2e.jpg";